import { MenuItem, TextField, useTheme } from "@mui/material";
import { useState } from "react";

export default function TextFieldSelect(props) {
  const {
    list,
    name,
    label,
    value,
    fullWidth,
    variant,
    margin,
    setFieldValue,
    setFieldTouched,
    onChange,
    error,
    helperText,
    InputProps,
    multiple,
    clearAll,
    required,
    renderValue,
    sx,
    disabled,
  } = props;

  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const highlightSelected =
    props.highlightSelected === undefined || props.highlightSelected;

  return (
    <TextField
      name={name}
      label={label}
      value={value}
      variant={variant || "outlined"}
      fullWidth={fullWidth}
      margin={margin || "normal"}
      disabled={disabled}
      onChange={(e) => {
        const {
          target: { value },
        } = e;
        if (onChange) {
          onChange(e);
        }

        if (setFieldTouched) {
          setFieldTouched(name);
        }
        if (value?.includes("***CLEARALL***")) {
          setFieldValue(name, multiple ? [] : "");
          setOpen(false);
        } else if (value?.includes("***CLOSE***")) {
          setOpen(false);
        } else {
          setFieldValue(
            name,
            typeof value === "string" && multiple ? value.split(",") : value
          );
        }
      }}
      error={error}
      helperText={helperText}
      InputProps={InputProps}
      select
      required={required}
      SelectProps={{
        open: open,
        onOpen: () => setOpen(true),
        onClose: () => setOpen(false),
        multiple: multiple,
        renderValue: renderValue,
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 48 * 4.5 + 8,
              width: 250,
            },
          },
        },
      }}
      sx={sx}
    >
      {clearAll && <MenuItem value="***CLEARALL***">Clear</MenuItem>}
      {list?.map((item, index) => {
        if (typeof item == "object") {
          return (
            <MenuItem
              key={index}
              value={item.value}
              selected={highlightSelected && value?.includes(item.value)}
            >
              {item.label}
            </MenuItem>
          );
        } else {
          return (
            <MenuItem
              key={index}
              value={item}
              fullWidth
              selected={highlightSelected && value?.includes(item)}
            >
              {item}
            </MenuItem>
          );
        }
      })}
      <MenuItem
        sx={{
          backgroundColor: theme?.palette?.success?.main,
          color: theme?.palette?.success?.contrastText,
          "&:hover": {
            backgroundColor: theme?.palette?.success?.dark,
          },
        }}
        value="***CLOSE***"
      >
        Close
      </MenuItem>
    </TextField>
  );
}
